const model = {
    roleDetails: null,
    loading: false,
    error: null,
};

export default model;